<template>
  <BaseModal
    :open="open"
    size="s"
    role="alertdialog"
    :title-id="titleId"
    :persistent="busy"
    @close="cancel"
  >
    <div class="confirm-dialog">
          <div class="confirm-heading">
            <span class="confirm-icon" :class="{ danger }"><AlertTriangle v-if="danger" :size="23" /><CircleHelp v-else :size="23" /></span>
            <div><p v-if="eyebrow" class="confirm-eyebrow">{{ eyebrow }}</p><h3 :id="titleId">{{ title }}</h3></div>
          </div>
          <p class="confirm-message">{{ message }}</p>
          <div class="confirm-actions">
            <button class="ghost-btn" type="button" :disabled="busy" @click="cancel">
              {{ cancelText }}
            </button>
            <button
              class="brand-btn"
              :class="{ 'danger-btn': danger }"
              type="button"
              :disabled="busy"
              @click="$emit('confirm')"
            >
              {{ busy ? busyText : confirmText }}
            </button>
          </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { computed } from "vue";
import { AlertTriangle, CircleHelp } from "@lucide/vue";
import BaseModal from "./overlays/BaseModal.vue";

const props = defineProps({
  open: { type: Boolean, default: false },
  eyebrow: { type: String, default: "" },
  title: { type: String, required: true },
  message: { type: String, default: "" },
  confirmText: { type: String, default: "确定" },
  cancelText: { type: String, default: "取消" },
  busyText: { type: String, default: "处理中" },
  busy: { type: Boolean, default: false },
  danger: { type: Boolean, default: false }
});

const emit = defineEmits(["confirm", "cancel"]);
const titleId = computed(() => `confirm-title-${props.title.length}`);

function cancel() {
  if (!props.busy) emit("cancel");
}
</script>

<style scoped>
.confirm-dialog {
  padding: 26px;
  background: linear-gradient(165deg,#fff,#fffaf6);
  color: var(--text);
}
.confirm-heading{display:grid;grid-template-columns:48px 1fr;gap:13px;align-items:start}
.confirm-icon{width:48px;height:48px;display:grid;place-items:center;border-radius:15px;color:var(--ui-primary);background:var(--ui-primary-soft)}
.confirm-icon.danger{color:#c74b45;background:#fff0ee}

.confirm-eyebrow {
  margin: 0;
  color: #b64d47;
  font-size: 12px;
  font-weight: 900;
}

.confirm-dialog h3 {
  margin: 4px 0 13px;
  font-size: 25px;
  line-height: 1.3;
}

.confirm-message {
  margin: 0;
  color: var(--muted);
  line-height: 1.7;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.confirm-actions button {
  min-width: 96px;
}

.danger-btn {
  border-color: #c94f49;
  background: #c94f49;
  color: #fff;
}

.danger-btn:hover:not(:disabled) {
  border-color: #b33e39;
  background: #b33e39;
}

.confirm-actions button:disabled {
  opacity: .65;
  cursor: wait;
}

@media (max-width: 520px) {
  .confirm-dialog{padding:22px}
  .confirm-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
</style>
